import React, { useEffect } from 'react';

const Documentation = () => {
  useEffect(() => {
    window.location.href = 'https://www.notion.so/Planubo-Help-Doc-63b7b34ee37c402383211473b58be8fb';
  }, []);

  return (
    <div className="mt-8 ml-8">
      <h2>Redirect to Planubo Help Docs in progress...</h2>
    </div>
  );
};

export default Documentation;
